module.exports = __webpack_public_path__ + "static/media/se.b039bdb8.svg";